import React, { useState } from 'react';
import { Box, Button, useTheme, useMediaQuery } from '@mui/material';
import Crop from './Crop';
import Variety from './Variety';

const CropVarietyIndex = () => {
  const [view, setView] = useState('crop');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tabs = [
    { label: 'Crop', value: 'crop' },
    { label: 'Variety', value: 'variety' },
  ];
  return (
    <Box sx={{ minHeight: '100vh',  }}>
      {/* Tabs - match Location UI */}
      <Box
        sx={{
          width: { xs: '100%', sm: '100%' },
          mt: { xs: 0, sm: 8, md: 0 },
          position: { xs: 'fixed', sm: 'static' },
          left: 0,
          bottom: { xs: 0, sm: 'auto' },
          zIndex: 1200,
          bgcolor: { xs: '#fff', sm: 'transparent' },
          boxShadow: { xs: '0px -2px 12px rgba(0,0,0,0.08)', sm: 'none' },
          p: { xs: 1, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: { xs: 'grid', sm: 'inline-flex' },
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'none' },
            gridTemplateRows: { xs: 'repeat(1, 1fr)', sm: 'none' },
            gap: 1,
            p: 1,
            borderRadius: { xs: 0, sm: '14px' },
            bgcolor: { xs: '#fff', sm: '#fff' },
            boxShadow: { xs: 'none', sm: '0px 4px 12px rgba(0,0,0,0.08)' },
            width: { xs: '100%', sm: 'max-content' },
            overflowX: { xs: 'hidden', sm: isMobile ? 'auto' : 'visible' },
            whiteSpace: { xs: 'normal', sm: 'nowrap' },
          }}
        >
          {tabs.map((tab) => (
            <Button
              key={tab.value}
              onClick={() => setView(tab.value)}
              sx={{
                px: { xs: 0, sm: 3 },
                py: { xs: 1, sm: 1 },
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 300,
                fontSize: { xs: '13px', sm: '14px' },
                color: view === tab.value ? '#fff' : '#333',
                bgcolor: view === tab.value ? '#4F46E5' : 'transparent',
                boxShadow:
                  view === tab.value ? '0px 4px 10px rgba(79,70,229,0.35)' : 'none',
                '&:hover': {
                  bgcolor: view === tab.value ? '#4F46E5' : 'rgba(0,0,0,0.04)',
                },
                flexShrink: 0,
                minWidth: { xs: 0, sm: 80 },
                width: { xs: '100%', sm: 'auto' },
                m: { xs: 0, sm: 0 },
              }}
            >
              {tab.label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ mt: { xs: 2, sm: 3 }, mb: { xs: 8, sm: 0 } }}>
        {view === 'crop' ? <Crop /> : <Variety />}
      </Box>
    </Box>
  );
};

export default CropVarietyIndex;
